import React, { useEffect, useState } from 'react';

const StatusTable = ({ priceData }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (priceData) {
      const newData = {};
      Object.keys(priceData).forEach((key) => {
        newData[key] = {
          manualCutOff: priceData[key].IsManualCutOffYN === 'Y' ? 'Yes' : 'No',
          manualPrice: priceData[key].IsManualPriceActivatedYN === 'Y' ? 'Yes' : 'No',
          circuitBreaker: priceData[key].IsCircuitBreakerActivatedYN === 'Y' ? 'Yes' : 'No',
        };
      });
      setData(newData);
    }
  }, [priceData]);

  // Get all available keys (e.g., XAU, XAG, etc.)
  const assetKeys = Object.keys(data);

  // Define the status rows and their corresponding data keys
  const statusRows = [
    { label: 'Manual Cut Off', key: 'manualCutOff' },
    { label: 'Manual Price', key: 'manualPrice' },
    { label: 'Circuit Breaker', key: 'circuitBreaker' },
  ];

  return (
    <table
      style={{
        borderCollapse: 'separate',
        borderSpacing: '20px 0',
        width: 'auto',
      }}
    >
      <thead>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: '20px' }}>STATUS</th>
          {assetKeys.map((asset) => (
            <th key={asset} style={{ textAlign: 'left', paddingRight: '20px' }}>
              {asset}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {statusRows.map((row, idx) => (
          <tr key={idx}>
            <td style={{ paddingRight: '20px' }}>{row.label}</td>
            {assetKeys.map((asset) => (
              <td key={asset} style={{ paddingRight: '20px' }}>
                {data[asset] ? data[asset][row.key] : ''}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default StatusTable;
